export default {
    path: 'mix_withdraw',
    component: () => import( /* webpackChunkName: "withdraw-list" */ '@/pages/mix/WithdrawList'),
    meta: {
        title: '账户提现记录'
    }
}